/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRoomRequest
 */
export interface CreateRoomRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateRoomRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateRoomRequest
     */
    level?: string | null;
}

/**
 * Check if a given object implements the CreateRoomRequest interface.
 */
export function instanceOfCreateRoomRequest(value: object): value is CreateRoomRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateRoomRequestFromJSON(json: any): CreateRoomRequest {
    return CreateRoomRequestFromJSONTyped(json, false);
}

export function CreateRoomRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRoomRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'level': json['level'] == null ? undefined : json['level'],
    };
}

export function CreateRoomRequestToJSON(json: any): CreateRoomRequest {
    return CreateRoomRequestToJSONTyped(json, false);
}

export function CreateRoomRequestToJSONTyped(value?: CreateRoomRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'level': value['level'],
    };
}

